var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,null,Object.assign({}, _vm.$data,
            {itemsTotal: _vm.itemsTotal,
            itemsCount: _vm.itemsCount,
            pageLimit: _vm.pageLimit,
            totalPages: _vm.totalPages,
            filteredItems: _vm.filteredItems,
            controlsChange: _vm.controlsChange,
            sortOptions: _vm.sortOptions,
            paginationShowNav: _vm.paginationShowNav,
            setPageNumber: _vm.setPageNumber,
            pageNum: _vm.pageNum}))],2)}
var staticRenderFns = []

export { render, staticRenderFns }